const pointify = (className, objectId) => ({
  __type: 'Pointer',
  className,
  objectId
});

function generatePassword(birthday = new Date()) {
  function convertDigits(number) {
    if (number > 1900) {
      return String(number).slice(2, 4);
    }
    if (number > 9) {
      return String(number);
    }
    return String(`0${number}`);
  }
  const day = convertDigits(birthday.getUTCDate());
  const month = convertDigits(birthday.getUTCMonth() + 1);
  const year = convertDigits(birthday.getFullYear());
  return day + month + year;
}

module.exports = { pointify, generatePassword };
